import { useState } from 'react';
import {
  GALLERY_SITES,
  galleryCardHref,
  galleryImageSrc,
  isLiveGallerySite,
  type GallerySite,
} from '../gallery';

function GalleryCard({
  site,
  href,
}: {
  site: GallerySite;
  href: string;
}) {
  const [showImage, setShowImage] = useState(true);
  const live = isLiveGallerySite(site);

  return (
    <a
      href={href}
      data-testid="gallery-card"
      data-slug={site.slug}
      {...(live ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      className="group bg-surface border border-border rounded-xl overflow-hidden hover:border-accent/50 transition-colors text-left flex flex-col"
    >
      <div className="aspect-[16/10] bg-surface2 overflow-hidden">
        {showImage ? (
          <img
            src={galleryImageSrc(site.slug)}
            alt={site.title}
            className="w-full h-full object-cover object-top"
            onError={() => setShowImage(false)}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center px-4">
            <span className="font-heading text-lg text-textp text-center">{site.title}</span>
          </div>
        )}
      </div>
      <div className="p-4 flex flex-col gap-1">
        <div className="flex items-center gap-2">
          <span className="text-[10px] uppercase tracking-widest text-texts font-mono">{site.type}</span>
          {live ? (
            <span className="text-[10px] uppercase tracking-widest text-accent font-mono">Live</span>
          ) : null}
        </div>
        <h3 className="text-base font-semibold text-textp group-hover:text-accent transition-colors">
          {site.title}
          {live ? <i className="ri-external-link-line ml-1.5 text-sm text-texts" aria-hidden /> : null}
        </h3>
        <p className="text-sm text-texts">{site.description || site.subject}</p>
      </div>
    </a>
  );
}

export default function SiteGallery() {
  return (
    <section className="py-16 px-6 max-w-7xl mx-auto" id="gallery" data-testid="site-gallery">
      <div className="mb-8">
        <span className="text-xs uppercase tracking-widest text-accent font-mono font-semibold">
          Apps like this
        </span>
        <h2 className="text-3xl font-bold tracking-tight text-textp mt-1">Businesses already on the pad</h2>
        <p className="text-texts text-sm mt-1 max-w-xl">
          Shipped products, plus starter screens you can describe from.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {GALLERY_SITES.map((site) => (
          <GalleryCard key={site.slug} site={site} href={galleryCardHref(site, [])} />
        ))}
      </div>
    </section>
  );
}
